export default "__VITE_ASSET__VUQwq_qS__"